export default __webpack_public_path__ + "static/media/o4.3461db68.jpg";